/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ShareSkillRequestBody = {
  /**
   * The skill ID.
   */
  skillId: string;
};

/** @internal */
export type ShareSkillRequestBody$Outbound = {
  skill_id: string;
};

/** @internal */
export const ShareSkillRequestBody$outboundSchema: z.ZodMiniType<
  ShareSkillRequestBody$Outbound,
  ShareSkillRequestBody
> = z.pipe(
  z.object({
    skillId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      skillId: "skill_id",
    });
  }),
);

export function shareSkillRequestBodyToJSON(
  shareSkillRequestBody: ShareSkillRequestBody,
): string {
  return JSON.stringify(
    ShareSkillRequestBody$outboundSchema.parse(shareSkillRequestBody),
  );
}
